import { useDataChange, useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (!value) return
    change(inext => {
      inext.data[value.selected] = value.value
      // reset for all the rest types
      value.options.forEach(option => {
        if (option.id === value.selected) return
        inext.data[option.id] = 0
      })
    })
  }
}
